/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from 'react';
import HighchartsReact from 'highcharts-react-official';
import EmptyState from 'Components/common/components/EmptyState';
import { SeriesType } from 'Types/PersonTypes';
import { useHighchartsModule } from 'Utils/hooks/useHighchartsModule';
import { Spin } from 'antd';

type Props = {
  axis: number[]
  data: SeriesType[]
};

const EngagementChart: React.FC<Props> = function EngagementChart(props: Props) {
  const {
    axis, data,
  } = props;
  const highcharts = useHighchartsModule();
  const [isEmpty, setIsEmpty] = useState(false);
  const [length, setLength] = useState(0);
  useEffect(() => {
    const empty = data.every((type) => type.data?.length === 0);
    if (data?.length > 1) { setLength(data[0].data?.length || 0); }
    if (empty) setIsEmpty(true);
    else setIsEmpty(false);
  }, [data]);

  const series = data?.length ? data : [{}];
  const options = {
    chart: {
      type: 'spline',
      height: 200,
    },
    tooltip: {
      shared: true,
    },
    title: {
      text: '',
    },
    subtitle: {
      text: '',
    },
    yAxis: {
      gridLineColor: 'transparent',
      opposite: true,
      title: {
        text: null,
      },
      labels: {
        enabled: false,
      },
    },
    xAxis: {
      type: 'datetime',
      labels: {
        format: '{value:%d %b}',
      },
      tickInterval: length > 13 ? 7 * 24 * 3600 * 1000 : 24 * 3600 * 1000,
    },
    accessibility: {
      gridLineWidth: 0,
    },
    legend: {
      enabled: false,
    },
    plotOptions: {
      line: {
        pointWidth: 16,
      },
      dataLabels: {
        enabled: false,
      },
      series: {
        marker: {
          symbol: 'circle',
        },
        label: {
          enabled: false,
          connectorAllowed: false,
        },
        pointStart: 2010,
      },
    },

    series,

    responsive: {
      rules: [{
        condition: {
          maxWidth: 500,
        },
        chartOptions: {
          legend: {
            layout: 'horizontal',
            align: 'center',
            verticalAlign: 'bottom',
          },
        },
      }],
    },
    exporting: { enabled: false },
    credits: {
      enabled: false,
    },
  };
  return (
    <div className="barlinechart">
      {isEmpty ? (
        <EmptyState
          msg="No analytics data found"
          detail=""
          height="200px"
        />
      )
        : highcharts ? <HighchartsReact highcharts={highcharts} options={options} /> : <Spin />}
    </div>
  );
};

export default EngagementChart;
